import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Returns a function whose identity never changes and which always runs the latest `handler`.
 * An effect can list it as a dependency without re-running when the values `handler` reads
 * change. Call it only from effects and event handlers, never during render.
 */
export function useEffectEventHook<Args extends unknown[], Result>(handler: (...args: Args) => Result) {
    const handlerRef = useRef(handler);

    useLayoutEffect(() => {
        handlerRef.current = handler;
    });

    return useCallback((...args: Args) => handlerRef.current(...args), []);
}
